"use client";
import { Award } from "lucide-react";
import { Button } from "../ui/button";
import { APP_SCHOLARSHIP_URL } from "@/client/components/shared";

export function ApplyButton() {
  return (
    <div className="flex flex-col sm:flex-row gap-6 justify-center animate-fade-in">
      <Button
        onClick={() =>
          window.open(APP_SCHOLARSHIP_URL, "_blank", "noopener,noreferrer")
        }
        size="lg"
        className="bg-nature-500 hover:bg-nature-600 text-white text-xl px-10 py-6 h-auto rounded-full shadow-xl transform hover:scale-105 transition-all duration-300"
      >
        <Award className="w-6 h-6 mr-2" />
        Apply for scholarship
      </Button>
    </div>
  );
}
